export default __webpack_public_path__ + "img/0238b74cf6ac20866c9f6021acd91c0e.png";